<template>
  <div>
    <v-tooltip :disabled="canClip" top>
      <template v-slot:activator="{ on }">
        <div
          :style="'background-color:' + bgColor + '!important;'"
          v-on="on"
          class="bar-clip wrap"
        />
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#BDBDBD',
    },
    canClip: {
      type: Boolean,
      default: true,
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.wrap {
  min-height: 26px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  width: 100%;
}
.bar-clip {
  clip-path: polygon(
    0% 0%,
    calc(100% - 24px) 0%,
    100% 50%,
    calc(100% - 24px) 100%,
    0% 100%,
    24px 49%
  );
}
</style>
